import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SidebarService } from 'app/main/services/sidebar.service';
import { AppSidebar, AppsSidebar, Sidebar } from '../../../models/sidebar';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() name: string;
  public sidebar: AppSidebar;
  public select: string;
  public class: string;
  public zIndex: string;
  public dark = false;
  constructor(
    private _sidebar: SidebarService,
  ) { }

  ngOnInit(): void {
    this.select = 'app-' + this.name;
    this.sidebar = this._sidebar.getSidebarData(this.name);
    this.setStyle();
    console.log('class', document.body.className);
    this.dark = document.body.className.includes('dark-layout');
  }

  setStyle = (): void => {
    const apps: AppsSidebar = this._sidebar.sidebarsRef.apps;
    const countOpen: number = Object.keys(apps)
      .reduce((count: number, name: string) => count + (apps[name].open?.value ? 1 : 0), 0);

    this.class = `sidebar-form ${this.sidebar.layout.position} w-${this.sidebar.layout.width}
      h-${this.sidebar.layout.height}`;
    this.zIndex = `z-index: ${5000 + countOpen};`;
  }

  ngAfterViewInit(): void {
    const active = `${this.sidebar.layout.position}-active`;
    setTimeout(() => {
      const sidebarElement: HTMLElement = document.getElementById('sidebar-' + this.name);
      sidebarElement.classList.add(active);
    }, 100);
  }

  // * Cerrar el sidebar;
  closeSidebar = (): void => {
    const active = `${this.sidebar.layout.position}-active`;
    const sidebarElement: HTMLElement = document.getElementById('sidebar-' + this.name);
    sidebarElement.classList.remove(active);
    setTimeout(() => {
      this._sidebar.close(this.name);
    }, 500);
  }

  ngOnDestroy(): void {
  }

}
